import React from 'react';
import classNames from 'classnames';

import Icon, { faCircleExclamation, faInfoCircle, faTriangleExclamation, IconProp } from '~components/icon';

export type CalloutTone = 'danger' | 'warning' | 'info';

export interface CalloutProps {
  tone: CalloutTone;
  title: string;
  /** Body lines, one paragraph each. */
  lines?: React.ReactNode[];
  /** Defaults by tone: danger faTriangleExclamation, warning faCircleExclamation, info faInfoCircle. */
  icon?: IconProp;
  className?: string;
  dataCy?: string;
}

/** Each tone's icon, also used by boxes that sit with a banner (e.g. the SaH over-limit box). */
export const CALLOUT_ICONS: Record<CalloutTone, IconProp> = {
  danger: faTriangleExclamation,
  warning: faCircleExclamation,
  info: faInfoCircle,
};

/** A tone banner (danger, warning or info) with an icon, a bold title and optional body lines. */
const Callout: React.FC<CalloutProps> = ({ tone, title, lines = [], icon, className, dataCy = 'callout' }) => (
  <div
    className={classNames('callout', tone, className)}
    role={tone === 'danger' ? 'alert' : 'status'}
    data-cy={dataCy}
  >
    <Icon icon={icon ?? CALLOUT_ICONS[tone]} className="callout-icon" aria-hidden />
    <div className="callout-body">
      <p className="callout-title">{title}</p>
      {lines.map((line, index) => (
        <p className="callout-line" key={index}>
          {line}
        </p>
      ))}
    </div>
  </div>
);

export default Callout;
